module.exports = __webpack_public_path__ + "img/nodataset.97b05369.png";